<template>
    <div class="global-accordion" :class="[theme, enumerate ? 'accordion--enumeration': '', open ? 'accordion--open': 'accordion--close']">
        <div class="global-accordion__header" :class="[headerType, inactive]" @click="toggle">
            <header :class="headerWidth">
                <template v-if="accordionType === '3'">
                    <span class="icon-toggle" :class="buttonState">
                        <span class="horizontal"></span>
                        <span class="vertical"></span>
                    </span>
                </template>

                <template v-if="accordionType === '2'">
                    <span class="header__enumeration"
                      v-if="enumerate">
                        {{ enumerate }}
                    </span>
                    <h2 class='headline-2'>
                        <slot name="header"/>
                    </h2>
                </template>

                <template v-if="accordionType === '3'">
                    <h3>
                        <slot name="header"/>
                        <span class="header__enumeration"
                              v-if="enumerate">
                            {{ enumerate }}
                        </span>
                    </h3>
                </template>

                <template v-if="accordionType === '2'">
                    <span class="icon-toggle" :class="buttonState">
                        <span class="horizontal"></span>
                        <span class="vertical"></span>
                    </span>
                </template>
            </header>
        </div>
        <transition name="accordion"
                    v-on:before-enter="beforeEnter"
                    v-on:enter="enter"
                    v-on:after-enter="enterTo"
                    v-on:before-leave="beforeLeave"
                    v-on:leave="leave"
                    v-on:after-leave="leaveTo">
            <div class="accordion__body" :class="{ 'accordion__body--staged': useContentStage }" v-show="open">
                <slot name="body"/>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: "global-accordion",
    props: {
        accordionType: {
            type: String,
            default: '2',
            validator: function (value) {
                return ['2', '3'].indexOf(value) !== -1
            }
        },
        useContentStage: {
            type: Boolean,
            default: false
        },
        animateMaxHeight: {
            type: Number,
        },
        theme: {
            type: String,
            default: '',
            validator: function (value) {
                return ['', 'theme--sustainability', 'theme--grey'].indexOf(value) !== -1;
            }
        },
        enumerate: {
            type: String,
            default: null
        },
        open: {
            type: Boolean,
            default: false
        },
        inactive: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        buttonState () {
            return this.open ? 'minus': 'plus'
        },
        headerType() {
            return this.accordionType === '2' ? 'accordion__header--headline-2' : 'accordion__header--headline-3'
        },
        headerWidth() {
            if (this.accordionType === '3') {
                return ''
            }
            return ''
        }
    },
    methods: {
        toggle() {
            if (!this.inactive) {
                this.$emit('toggleAccordion');
            }
        },
        beforeEnter: function(el) {
            el.style.maxHeight = '0';
            el.style.overflow = 'hidden';
        },
        enter: function(el) {
            el.style.maxHeight = this.animateMaxHeight ? this.animateMaxHeight + 'px': el.scrollHeight + 'px';
            el.style.overflow = 'hidden';
        },
        enterTo: function(el) {
            el.style.maxHeight = this.animateMaxHeight ? this.animateMaxHeight + 'px': '';
            el.style.overflow = this.animateMaxHeight ? 'auto': '';
        },
        beforeLeave: function(el) {
            el.style.maxHeight = this.animateMaxHeight ? this.animateMaxHeight + 'px': el.scrollHeight + 'px';
            el.style.overflow = 'hidden';
        },
        leave: function(el) {
            el.style.maxHeight = '0';
            el.style.overflow = 'hidden';
        },
        leaveTo: function(el) {
            el.style.maxHeight = '';
            el.style.overflow = '';
        },
    }
}
</script>

<style lang="scss" scoped>
    .accordion__body {
        transition: max-height 250ms ease-out !important;
    }
</style>
